import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const refreshDeviceToken = {
  name: "refreshDeviceToken" as const,
  input: z.object({ refreshToken: z.string() }),
  output: z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresAt: zExt.instant(), // Access token expiration
  }),
};
